import constants from '@/constants/constants';

/**
 * Custom Vue directive to hide an element based on the current user's access
 * to articles with a certain tag or set of tags.
 * To be considered accessible, the article must not have the INACTIVE status.
 */
export default(el, binding) =>
{
    // Retrieve directive parameters
    if(typeof binding.value !== 'string' && !Array.isArray(binding.value))
    {
        throw new Error('Invalid format for v-has-articles-by-tag directive.');
        // Valid formats are: <div v-has-active-articles-by-tag="'TAG_CODE'">
        //   - <div v-has-active-articles-by-tag="'TAG_CODE'">
        //   - <div v-has-active-articles-by-tag="['TAG_CODE1', 'TAG_CODE2']">
    }

    // At least one article in the user's catalog must have all selected tags
    const shouldDisplay = binding.instance.$store.getters['catalog/hasActiveArticlesByTag'](binding.value);

    if(shouldDisplay)
    {
        // Element is shown. Do nothing :-)
    }
    else
    {
        // Remove element from DOM
        el.remove();
    }
};
